import {
    GET_LIST_ANGGOTA,
    GET_LIST_ANGGOTA_SUCCESS,
    GET_LIST_ANGGOTA_FAIL,
  } from "./actionTypes";
  
  const initialState = {
    dataDaftarAnggota: {
      loading: false,
      error: false,
      data: null,
    },
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      // get table exco pusat
      case GET_LIST_ANGGOTA:
        return {
          ...state,
          dataDaftarAnggota: {
            ...state.dataDaftarAnggota,
            loading: true,
            error: false,
          },
        };
      case GET_LIST_ANGGOTA_SUCCESS:
        return {
          ...state,
          dataDaftarAnggota: {
            ...state.dataDaftarAnggota,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_LIST_ANGGOTA_FAIL:
        return {
          ...state,
          dataDaftarAnggota: {
            ...state.dataDaftarAnggota,
            loading: false,
            error: action.payload,
          },
      };
      default:
        return state;
    }
  };
  
  export default reducer;
  